import React, { Component } from 'react';
import Head from "../components/Head";
import { Tabs, Tab, Form, Button } from "react-bootstrap";
import { signup, signin, signInWithGoogle } from '../helpers/auth';
import { Redirect } from 'react-router-dom';
import { Container, SignInUp } from '../helpers/styles.js';
import login_image from '../assets/login_image.svg';
import '../App.js';

export default class Auth extends Component {


  constructor(props) {

    super(props);

    this.state = {
      error: null,
      email: '',
      password: '',


    };
    localStorage.clear();






    this.handleChange = this.handleChange.bind(this);
    this.handleReg = this.handleReg.bind(this);
    // this.googleSignIn = this.googleSignIn.bind(this);
    this.handleLog = this.handleLog.bind(this);


  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  async handleLog(event) {
    event.preventDefault();
    this.setState({ error: '' });

    try {
      if (typeof (this.props.location.state) !== 'undefined') {

        this.fromm = this.props.location.state.from.pathname;
        localStorage.setItem('from', this.fromm);

      }


      await signin(this.state.lemail, this.state.lpwd);




    } catch (error) {
      this.setState({ error: error.message });
    }
  }
  // async googleSignIn() {
  //   try {
  //     await signInWithGoogle();
  //     this.state = {
  //       user: auth().currentUser,
  //     }

  //   } catch (error) {
  //     this.setState({ error: error.message });
  //   }
  // }
  async handleReg(event) {
    event.preventDefault();
    this.setState({ error: '' });
    try {
      await signup(this.state.remail, this.state.rpwd);





    } catch (error) {
      this.setState({ error: error.message });
    }
  }



  render() {

    return (
      <Container>
        <img src={login_image} alt='main_image' />
        <SignInUp>
          <Tabs defaultActiveKey="Login" transition={false} id="noanim-tab-example">
            <Tab eventKey="Register" title="Register">
              <text></text>
              <Form onSubmit={this.handleReg} className="auth-form">
                <Form.Group controlId="formGroupEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control name="remail" onChange={this.handleChange} value={this.state.remail} id="remail" type="email" placeholder="Enter email" />
                </Form.Group>
                <Form.Group controlId="formGroupPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control name="rpwd" onChange={this.handleChange} value={this.state.rpwd} id="rpwd" type="password" placeholder="Password" />
                </Form.Group>
                {this.state.error ? <p className="text-danger">{this.state.error}</p> : null}
                <Button type="submit" variant="primary">Register</Button>

              </Form>
            </Tab>
            <Tab eventKey="Login" title="Login">

              <Form onSubmit={this.handleLog} className="auth-form">
                <Form.Group controlId="formGroupEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control name="lemail" onChange={this.handleChange} value={this.state.lemail} id="lemail" type="email" placeholder="Enter email" />
                </Form.Group>
                <Form.Group controlId="formGroupPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control name="lpwd" onChange={this.handleChange} value={this.state.lpwd} id="lpwd" type="password" placeholder="Password" />
                </Form.Group>
                {this.state.error ? <strong> <p className="text-danger">{this.state.error}</p></strong> : null}
                <Button type="submit" variant="primary">Login</Button>
                <p>Or</p>
                <button onClick={this.googleSignIn} type="button">
                  Sign up with Google
                </button>
              </Form>
            </Tab>
          </Tabs>
        </SignInUp>
      </Container>
    );
  }
}